// extracted by mini-css-extract-plugin
export default {"wrap":"NotesHeader_wrap__WsPna","backward":"NotesHeader_backward__owsc-"};